import {component} from 'picoapp'

export default component(async (node) => {
  const paginationType = node.dataset.pagination
  const results = node.querySelector('[data-results]')
  const loadMore = node.querySelector('[data-load-more]')
  const infiniteScroll = node.querySelector('[data-infinite-scroll]')

  let currentPage = parseInt(node.dataset.currentPage, 10)
  let totalPages = parseInt(node.dataset.totalPages, 10)

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.disconnect()

          fetchNextPage()
        }
      })
    }
  )

  if (loadMore) {
    loadMore.addEventListener('click', () => {
      fetchNextPage()
    })
  }

  const renderProducts = (response) => {
    results.insertAdjacentHTML('beforeend', response)
    totalPages = +results.lastElementChild.dataset.pages
  }

  const fetchProducts = async (query) => {
    const queryString = new URLSearchParams(query)

    queryString.set('page', currentPage)
    queryString.set('view', 'data')

    await fetch(`?${queryString.toString()}`)
      .then((response) => response.text())
      .then((response) => renderProducts(response))

    app.mount()

    if (paginationType === 'button') {
      const collectionTotal = document.querySelector('#collectionTotal'),
        collectionCurrent = document.querySelector('#collectionCurrent'),
        collectionProgress = document.querySelector('.pagination-button-progress'),
        currentOffset = 20,
        productCount = +results.lastElementChild.dataset.count

      collectionCurrent.textContent = ((currentOffset * currentPage) >= productCount ? productCount : currentOffset * currentPage)
      collectionTotal.textContent = productCount
      collectionProgress.style.width = (((currentOffset * currentPage) * 100) / productCount > 100 ? 100 : ((currentOffset * currentPage) * 100) / productCount) + "%"
      if (currentPage === totalPages) loadMore.style.display = 'none'
      else loadMore.style.display = null
    }
  }

  const fetchNextPage = async () => {
    currentPage += 1

    if (currentPage > totalPages) {
      return
    }

    const query = new URLSearchParams(location.search)
    query.set('page', currentPage)

    await fetchProducts(query.toString())
  }

  if (infiniteScroll) observer.observe(infiniteScroll)
})
